if (!customElements.get('tsx-pack-progress')) {
  customElements.define('tsx-pack-progress', class extends HTMLElement {
    connectedCallback() {
      if (this.unsubscribe || !this.dataset.section || !this.dataset.url) return;
      this.refresh = this.refresh.bind(this);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh);
      }
      this.onPageShow = (event) => { if (event.persisted) this.refresh(); };
      window.addEventListener('pageshow', this.onPageShow);
    }

    disconnectedCallback() {
      this.unsubscribe?.();
      this.unsubscribe = null;
      this.controller?.abort();
      window.removeEventListener('pageshow', this.onPageShow);
    }

    async refresh() {
      this.controller?.abort();
      this.controller = new AbortController();
      try {
        const url = new URL(this.dataset.url, window.location.origin);
        url.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(url.toString(), { cache: 'no-store', signal: this.controller.signal });
        if (!response.ok) return;
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const updated = document.querySelector('tsx-pack-progress');
        if (!updated || !this.isConnected) return;
        this.innerHTML = updated.innerHTML;
        this.className = updated.className;
        this.dataset.pairs = updated.dataset.pairs;
        this.dataset.total = updated.dataset.total;
      } catch (error) {
        if (error.name !== 'AbortError') console.warn('TipSoxx pack progress could not refresh.');
      }
    }
  });
}
